import { render, staticRenderFns } from "./devSettings.vue?vue&type=template&id=c5e554ba&scoped=true"
import script from "./devSettings.vue?vue&type=script&lang=js"
export * from "./devSettings.vue?vue&type=script&lang=js"
import style0 from "./devSettings.vue?vue&type=style&index=0&id=c5e554ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5e554ba",
  null
  
)

export default component.exports